module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/redirect-page/redirect-page.component.less
// module id = ./src/app/pages/redirect-page/redirect-page.component.less
// module chunks = main